import cx from 'classnames';
import styles from '../../styles/index.scss';

interface Props {
  type?: string;
  float?: string;
  disabled?: boolean;
  className?: string;
  onClick?: any;
  loadingLabel?: any;
  label: string;
  showBadge?: boolean;
  count?: number;
  badgeStyles?: string;
}

const Button = (props: Props) => (
  <button
    className={cx(
      'font--white',
      styles['save-btn'],
      props.className,
      styles[props.type],
      styles[props.float],
      props.disabled ? 'disabled' : ''
    )}
    type={props.type}
    onClick={props.disabled ? null : props.onClick}
  >
    {props.disabled ? props.loadingLabel : props.label}
    {props.showBadge ? (
      <span className={cx(props.badgeStyles, 'font--bold text--sm')}>
        {props.count}
      </span>
    ) : null}

    <style jsx>{`
      .loading,
      .disabled {
        opacity: 0.6;
        cursor: initial;
        pointer-events: none;
      }
      .btn-action-blue.disabled {
        background-color: #d9d9d9;
        color: #999999;
      }
      button {
        color: #fff;
      }
    `}</style>
  </button>
);

export default Button;



// WEBPACK FOOTER //
// ./components/ui/button.tsx